import {ModuleWithProviders, NgModule} from '@angular/core';
import { EyeTrackerComponent } from './eye-tracker.component';
import { TechnicalCheckComponent } from './technical-check/technical-check.component';
import { CalibrationComponent } from './calibration/calibration.component';
import { VisualTestComponent } from './visual-test/visual-test.component';
import {CommonModule} from '@angular/common';
import { SlideComponent } from './visual-test/slide/slide.component';
import {NgbProgressbarModule, NgbTooltipModule} from '@ng-bootstrap/ng-bootstrap';
import {EyeTrackerService} from 'projects/eye-tracker/src/lib/eye-tracker.service';
import {SharedModule} from 'projects/shared/src/lib/shared.module';
import { ErrorAlertComponent } from './error-alert/error-alert.component';
import {FormsModule} from '@angular/forms';
import {SlickCarouselModule} from 'ngx-slick-carousel';
import { StopTestConfirmationModalComponent } from './stop-test-confirmation-modal/stop-test-confirmation-modal.component';
import {Configurations} from 'projects/eye-tracker/src/lib/configurations';
import { GazeFixationComponent } from './gaze-fixation/gaze-fixation.component';
import { GridCalibrationComponent } from './calibration/grid-calibration/grid-calibration.component';
import {CircularProgressComponent} from './components/circle-progress/circle-progress.component';
import { DastRendererComponent } from './components/dast-renderer/dast-renderer.component';
import { ReadingInstructionsComponent } from './visual-test/reading-instructions/reading-instructions.component';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {HttpLoaderFactory} from '../../../paid/src/app/app.module';

@NgModule({
  declarations: [
    EyeTrackerComponent,
    TechnicalCheckComponent,
    CalibrationComponent,
    VisualTestComponent,
    SlideComponent,
    ErrorAlertComponent,
    StopTestConfirmationModalComponent,
    GazeFixationComponent,
    GridCalibrationComponent,
    CircularProgressComponent,
    DastRendererComponent,
    ReadingInstructionsComponent
  ],
  imports: [
    CommonModule,
    NgbProgressbarModule,
      NgbTooltipModule,
    SharedModule,
    FormsModule,
    SlickCarouselModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      defaultLanguage: 'en'
    }),
  ],
  exports: [
    EyeTrackerComponent,
    SlideComponent,
    CircularProgressComponent,
    GridCalibrationComponent,
    DastRendererComponent
  ],
  providers: [EyeTrackerService]
})
export class EyeTrackerModule {
  public static forRoot(config: Configurations): ModuleWithProviders<EyeTrackerModule> {

    return {
      ngModule: EyeTrackerModule,
      providers: [
        { provide: Configurations, useValue: config }
      ]
    };
  }
}
